import { useState } from 'react';
import api from '@/lib/apiClient';
import { formatApiError } from '@/lib/utils';
import { Lock, Eye, EyeOff, Loader2, ShieldCheck } from 'lucide-react';

const LOGO = "https://customer-assets.emergentagent.com/job_9b5e32bd-6e03-4600-841f-a63162f850e8/artifacts/w487gkes_lexorbit-logo.png.png";
const IC = "w-full bg-white/[0.04] border border-[rgba(201,164,76,0.15)] text-[#F8F6F0] placeholder-[#888]/50 rounded-lg px-4 py-3 pl-11 text-sm focus:outline-none focus:border-[#C9A44C] focus:ring-1 focus:ring-[#C9A44C]/50 transition-all";

export default function PrimerLoginModal({ onCompletado }) {
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nueva !== confirmar) { setErr('Las contraseñas no coinciden'); return; }
    if (nueva.length < 8) { setErr('Mínimo 8 caracteres'); return; }
    setErr(''); setLoading(true);
    try {
      await api.post('/api/cambiar-password-inicial', { nueva_password: nueva, confirmar_password: confirmar });
      onCompletado();
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail, 'Error al cambiar la contraseña'));
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/90 backdrop-blur-md p-4">
      <div className="w-full max-w-sm bg-[#0A0A0A]/95 border border-[rgba(201,164,76,0.2)] rounded-2xl p-8">
        <div className="text-center mb-7">
          <img src={LOGO} alt="LexOrbit" className="h-12 mx-auto mb-4" />
          <div className="w-12 h-12 rounded-full bg-[#C9A44C]/15 border border-[#C9A44C]/30 flex items-center justify-center mx-auto mb-3">
            <ShieldCheck className="w-6 h-6 text-[#C9A44C]" />
          </div>
          <h2 className="text-xl text-[#F8F6F0]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Primer acceso
          </h2>
          <p className="text-xs text-[#888] mt-2 leading-relaxed">
            Por seguridad, debés establecer una contraseña propia antes de continuar.
          </p>
        </div>

        {err && <div className="bg-red-500/10 border border-red-500/25 rounded-lg p-3 mb-4 text-red-400 text-xs">{err}</div>}

        <form onSubmit={submit} className="space-y-3.5">
          <div className="relative">
            <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-[#888]/50" />
            <input type={show ? 'text' : 'password'} className={IC} placeholder="Nueva contraseña"
              value={nueva} onChange={(e) => setNueva(e.target.value)} required />
            <button type="button" onClick={() => setShow(!show)}
              className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#888] hover:text-[#C9A44C]">
              {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
          <div className="relative">
            <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-[#888]/50" />
            <input type="password" className={IC} placeholder="Confirmar contraseña"
              value={confirmar} onChange={(e) => setConfirmar(e.target.value)} required />
          </div>
          <p className="text-[10px] text-[#666]">Mínimo 8 caracteres.</p>
          <button type="submit" disabled={loading}
            className="w-full text-[#070707] font-bold py-3 rounded-lg flex items-center justify-center gap-2 text-sm disabled:opacity-50"
            style={{ background: 'linear-gradient(135deg, #C9A44C, #E0C878)' }}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Establecer contraseña y continuar'}
          </button>
        </form>
      </div>
    </div>
  );
}
